// tabs/equipment-slots.ts — client port of the PC sheet's Equipment Slots tab
//   options/game/character_sheet_display/equipment_slots/_equipment_slots_inc.php
//
// Reuses the SHIPPED, blob-correct equipment-slot grid from the inventory bundle
// (window.renderEquipmentSlotGrid), which reads the `inventory_equipped` layer and
// renders item THUMBNAILS per slot. This is a modernization over the legacy PHP
// paper-doll of icon buttons (which keyed off a top-level `equipped` column that the
// inventory source-table reshape moved into entry.inventory.equipped — i.e. the PHP
// tab reads stale and shows empty slots). The grid is the canonical reader.

import type { CachedCaster } from '../types';

export function buildEquipmentSlotsHtml(caster: CachedCaster): string {
    let grid = '';
    try {
        if (typeof window.renderEquipmentSlotGrid === 'function') {
            grid = window.renderEquipmentSlotGrid(caster) || '';
        }
    } catch (e) {
        console.error('[pc-sheet] equipment-slots render failed', e);
    }
    const body = grid !== ''
        ? grid
        : `<div class="ft-pc-equip__empty">No equipped items.</div>`;
    return `<div class="ft-pc-equip">${body}</div>`;
}
